import {
    HStack, Link, Stack, Stat, StatArrow, StatHelpText, StatLabel,
    StatNumber, Text, VStack
} from "@chakra-ui/react";
import useWindowSize from "../hooks/useWindowSize";
import formatter from "./../util/formatter";
import Button from "./Button/Button";

const bitmamaUrl = "https://www.bitmama.io/"

const toUpper = (str) => String(str).toUpperCase()
  
const Widget = ({data: datum, height, scale: scalum, padding, zIndex = 10, ...cProps}) => {
    const windowSize = useWindowSize();
    const scale = !isNaN(scalum) && Number(scalum) < 5 ? Number(scalum) : 1;
    let cScale = scale;
    if(cScale < 0) {
        cScale = 1;
    }
    const smSize = windowSize.width < 600;

    if(!datum) return null;
    const data = Object.keys(datum).map((d) => ({...datum[d]})).sort((a, b) => String(a.token).toLowerCase() > String(b.token).toLowerCase() ? 1 : -1)
    if(!data.length) return null;
    return (
        <Stack bg="white" borderTop={`${6 * scale}px solid #03A438`} height={height} p={padding ?? `${10 * scale}px`}>
            <HStack
                overflowX="hidden"
                zIndex={zIndex}
                {...cProps}
            >
                {scale > 0 ? <HStack
                overflowX="scroll"
                sx={{
                "::-webkit-scrollbar": {
                    h: ".2em",
                },
                "::-webkit-scrollbar-thumb": {
                    bg: "transparent",
                },
                width: "100%"
                }}
            >
                {data.map((d) => (
                <Stat key={d.token} as={VStack} bg="#F7F7FC" p={`${8 * scale}}px`} minW={`${120 * scale}px`}>
                    <StatLabel fontSize={`${scale * 0.875}rem`} textAlign="center" color="gray.800">
                    {toUpper(d.token)}
                    </StatLabel>
                    <StatNumber textAlign="center" fontSize={`${1.125 * scale}rem`} color="#02472A">
                    {formatter("usd").format(d.price)}
                    </StatNumber>
                    <StatHelpText
                    as={HStack}
                    alignItems="center"
                    fontSize={`${0.875 * scale}rem`}
                    color={d.gain < 0 ? "red.400" : "green.500"}
                    mb="0 !important"
                    >
                    <StatArrow
                        boxSize={`${12 * scale}px`}
                        type={d.gain < 0 ? "decrease" : "increase"}
                    />
                    <Text fontSize="inherit" color="inherit">
                        {d.gain}%
                    </Text>
                    </StatHelpText>
                </Stat>
                ))}
            </HStack> : null}
            <HStack>
                <Link color="green.500" href={bitmamaUrl} isExternal>
                    <Stat as={VStack} bg="#ffffff" p={{ base: `${4 * cScale}px`, md: `${6 * cScale}px` }} minW={{ base: `${80 * cScale}px`, md: `${100 * cScale}px`, lg: `${120 * cScale}px` }}>
                        <StatLabel fontSize={{base: `${0.875 * cScale}rem`, md: `${1 * cScale}rem`}} textAlign="center" color="gray.800">
                        <Button
                            w="100%"
                            disabled={false}
                            minH={{ base: (24 * cScale) + "px", md: (48 * cScale) + "px" }}
                            {...(smSize && {minW: (24 * cScale) + "px", fontSize: `${0.875 * cScale}rem`, padding: `${0.5 * cScale}rem ${1.25 * cScale}rem`})}
                        >
                            Trade Now
                        </Button>
                        </StatLabel>
                        
                        <StatHelpText
                            as={HStack}
                            alignItems="center"
                            justifyContent="center"
                            fontSize={`${1 * cScale}rem`}
                            mb="0 !important"
                        >
                            <Text fontSize={`${0.75 * cScale}rem`} fontStyle="italic" textAlign="center">
                                {!smSize ? "powered by " : "on "}Bitmama
                            </Text>
                        </StatHelpText>
                    </Stat>
                </Link>
            </HStack>
            </HStack>
        </Stack>
    );
};
  
export default Widget;
